<template>
  <div class="circle-bar">
    <div class="circle-legend">
      <span class="icon" />
      <span class="title">{{ lengendTitle }}</span>
    </div>
    <van-circle v-model="currentRate" layer-color="#ebedf0" :rate="rate" :speed="100" :stroke-width="60" :text="text" />
  </div>
</template>

<script>
export default {
  name: 'CircleBar',
  components: {},
  props: {
    rate: {
      type: Number,
      default: 0
    },
    lengendTitle: {
      type: String,
      default: ''
    },
    strokeWidth: {
      type: Number,
      default: 40
    }
  },
  data() {
    return {
      currentRate: 0
    }
  },
  computed: {
    text() {
      return this.rate + '%'
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.circle-bar {
  display: flex;
  justify-content: center;
  margin: 60px auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .circle-legend {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #333333;
    padding-bottom: 10px;
    .icon {
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #408afd;
      border-radius: 4px;
      margin-right:5px;
    }
  }
}
</style>
